"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Add2 = _interopRequireDefault(require("@material-ui/icons/Add"));

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _Close2 = _interopRequireDefault(require("@material-ui/icons/Close"));

var _InputBase2 = _interopRequireDefault(require("@material-ui/core/InputBase"));

var _ArrowDropDownCircle2 = _interopRequireDefault(require("@material-ui/icons/ArrowDropDownCircle"));

var _react = _interopRequireDefault(require("react"));

var _ModalColorSelect = _interopRequireDefault(require("../../components/ModalColorSelect"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var SingleSelect = function SingleSelect(_ref) {
  var _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options,
      setOptions = _ref.setOptions;
  var list = (options === null || options === void 0 ? void 0 : options.options) || [];

  var buttonSelectColorRef = _react["default"].useRef(new Array());

  var _React$useState = _react["default"].useState(-1),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      openColorSelectIndex = _React$useState2[0],
      setOpenColorSelectIndex = _React$useState2[1];

  var handleChange = function handleChange(index, e) {
    setOptions(_objectSpread(_objectSpread({}, options), {}, {
      options: list.map(function (item, id) {
        if (id === index) {
          return _objectSpread(_objectSpread({}, item), {}, {
            value: e.target.value
          });
        }

        return item;
      })
    }));
  };

  var handleChangeColor = function handleChangeColor(index, color) {
    setOptions(_objectSpread(_objectSpread({}, options), {}, {
      options: list.map(function (item, id) {
        if (id === index) {
          return _objectSpread(_objectSpread({}, item), {}, {
            color: color
          });
        }

        return item;
      })
    }));
    handleCloseSelectColor();
  };

  var handleRemove = function handleRemove(index) {
    setOptions(_objectSpread(_objectSpread({}, options), {}, {
      options: list.filter(function (item, id) {
        return id != index;
      })
    }));
  };

  var handleAdd = function handleAdd() {
    setOptions(_objectSpread(_objectSpread({}, options), {}, {
      options: [].concat(_toConsumableArray(list), [{
        value: "",
        color: "blue"
      }])
    }));
  };

  var handleCloseSelectColor = function handleCloseSelectColor() {
    setOpenColorSelectIndex(-1);
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginTop: "0.25rem",
      paddingRight: "1rem",
      fontSize: "0.875rem",
      color: "rgba(156, 163, 175, 1)"
    }
  }, list.length ? list.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      style: {
        display: "flex",
        marginTop: "0.25rem"
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: "flex",
        alignItems: "center",
        cursor: "pointer"
      }
    }, /*#__PURE__*/_react["default"].createElement(_ArrowDropDownCircle2["default"], {
      ref: function ref(el) {
        return buttonSelectColorRef.current[index] = el;
      },
      fontSize: "small",
      style: {
        color: item.color
      },
      onClick: function onClick() {
        return setOpenColorSelectIndex(index);
      }
    }), /*#__PURE__*/_react["default"].createElement(_ModalColorSelect["default"], {
      id: index,
      anchorEl: buttonSelectColorRef.current[index],
      open: index === openColorSelectIndex,
      handleClose: handleCloseSelectColor,
      title: item.value,
      onChange: handleChangeColor
    })), /*#__PURE__*/_react["default"].createElement(_InputBase2["default"], {
      value: item.value,
      onChange: function onChange(e) {
        return handleChange(index, e);
      },
      style: {
        backgroundColor: "rgba(0,0,0,0.05)",
        borderRadius: "0.25rem",
        paddingLeft: "0.25rem",
        paddingRight: "0.25rem",
        marginLeft: "0.25rem",
        marginRight: "0.25rem",
        fontSize: "0.875rem"
      },
      fullWidth: true,
      autoFocus: true
    }), /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
      style: {
        display: "flex",
        alignItems: "center",
        cursor: "pointer"
      },
      onClick: function onClick() {
        return handleRemove(index);
      }
    }, /*#__PURE__*/_react["default"].createElement(_Close2["default"], {
      fontSize: "small"
    })));
  }) : /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginTop: "0.5rem",
      textAlign: "center"
    }
  }, "No options defined"), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      borderBottom: "2px solid rgba(0,0,0,0.05)",
      paddingBottom: "0.25rem"
    }
  }, /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    style: {
      marginTop: "0.5rem",
      display: "flex",
      backgroundColor: "rgba(0,0,0,0.05)",
      color: "rgba(55, 65, 81, 1)",
      padding: "0.25rem",
      borderRadius: "0.25rem",
      cursor: "pointer"
    },
    onClick: handleAdd
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/_react["default"].createElement(_Add2["default"], {
    style: {
      fontSize: "1rem"
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginLeft: "0.25rem",
      fontWeight: 500
    }
  }, "Add an option"))));
};

var _default = SingleSelect;
exports["default"] = _default;